
export default {
  name: 'icon-parking',
};
